import { Alert, Button, Space, Table, Typography } from "antd";
import { useCallback, useState } from "react";
import { api, errorText } from "../api";
import { dateTime } from "../format";
import { useResource } from "../useResource";

/** `AuditRecord` */
export interface AuditItem {
  id: number;
  occurredAt: string;
  actorType: string;
  actorId: string | null;
  action: string;
  targetType: string | null;
  targetId: string | null;
  reason: string | null;
}

interface Page {
  items: AuditItem[];
  nextBefore: number | null;
}

const ACTOR: Record<string, string> = { USER: "Kullanıcı", PLATFORM_OPS: "Platform operasyonu", SYSTEM: "Sistem" };

/** Audit kayıtları, salt okunur (v0.9 §14.3). Yeniden eskiye; "Daha eski" ile sayfalanır. */
export function AuditPage() {
  const first = useResource(useCallback(() => api.get<Page>("/api/console/audit?limit=50"), []));
  // "Daha eski" ile eklenen sayfalar.
  const [older, setOlder] = useState<Page[]>([]);
  const [loading, setLoading] = useState(false);
  const [moreError, setMoreError] = useState<string | null>(null);
  const pages = first.data ? [first.data, ...older] : [];
  const items = pages.flatMap((p) => p.items);
  const next = pages.at(-1)?.nextBefore ?? null;
  const error = first.error ?? moreError;

  async function loadOlder(before: number) {
    setLoading(true);
    try {
      const page = await api.get<Page>(`/api/console/audit?limit=50&before=${before}`);
      setOlder((current) => [...current, page]);
    } catch (e) {
      setMoreError(errorText(e));
    } finally {
      setLoading(false);
    }
  }

  if (error) {
    return <Alert type="error" title={error} showIcon />;
  }
  return (
    <Space orientation="vertical" size="large" style={{ width: "100%" }}>
      <Typography.Title level={3}>Audit kayıtları</Typography.Title>
      <Table<AuditItem> rowKey="id" dataSource={items} pagination={false} size="small" loading={!first.data}
        columns={[
          { title: "Zaman", dataIndex: "occurredAt", width: 180, render: dateTime },
          { title: "Aktör", key: "actor", width: 220,
            render: (_: unknown, r: AuditItem) => `${ACTOR[r.actorType] ?? r.actorType}${r.actorId ? ` #${r.actorId}` : ""}` },
          { title: "İşlem", dataIndex: "action" },
          { title: "Hedef", key: "target", render: (_: unknown, r: AuditItem) => (r.targetType ? `${r.targetType} ${r.targetId ?? ""}` : "—") },
          { title: "Gerekçe", dataIndex: "reason", render: (v: string | null) => v ?? "—" },
        ]} />
      {next && <Button onClick={() => void loadOlder(next)} loading={loading}>Daha eski kayıtlar</Button>}
    </Space>
  );
}
